var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'card-viewer': true, 'dual-faced': _vm.dual_faced }},[_c('img',{attrs:{"src":_vm.card_preview,"draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }